var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlutterApp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 70.29 122.88",
    style: {
      enableBackground: "new 0 0 70.29 122.88"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill-rule:evenodd;clip-rule:evenodd;} .st1{fill-rule:evenodd;clip-rule:evenodd;fill:#47C5FB;} .st2{fill-rule:evenodd;clip-rule:evenodd;fill:#00569E;} .st3{fill-rule:evenodd;clip-rule:evenodd;fill:#00B5F8;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.26,0h43.76C60.67,0,64,1.49,66.4,3.88c2.4,2.4,3.89,5.73,3.89,9.38v96.36c0,3.65-1.49,6.98-3.89,9.38 c-2.39,2.39-5.73,3.88-9.38,3.88H13.26c-3.65,0-6.98-1.49-9.38-3.88C1.49,116.6,0,113.27,0,109.62V13.26 c0-3.65,1.49-6.98,3.89-9.38C6.28,1.49,9.61,0,13.26,0L13.26,0L13.26,0L13.26,0z M67.09,104.67V13.69H3.18v90.96 C25.41,104.66,44.87,104.67,67.09,104.67L67.09,104.67L67.09,104.67z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "35.36,32.19 11.23,56.31 18.7,63.78 50.29,32.19 35.36,32.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "35.19,54.44 22.27,67.35 29.77,74.96 37.22,67.5 50.29,54.44 35.19,54.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "29.77,74.96 35.44,80.63 50.29,80.63 37.22,67.5 29.77,74.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "22.19,67.43 29.65,59.97 37.22,67.5 29.77,74.96 22.19,67.43"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlutterApp);
export default __webpack_public_path__ + "static/media/flutter_app.6a9d3de972c2b1e8f053b8c50bb9a2fe.svg";
export { ForwardRef as ReactComponent };